var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254,
    height: 161,
    fill: "none",
    viewBox: "0 0 254 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F7",
    fillRule: "evenodd",
    d: "M43.84 73.258c-2.08 2.48-3.76 5.44-3.6 8.56.32 5.92 7.12 9.44 13.12 9.44 5.92 0 11.76-2.24 17.68-2.16 3.04 0 6.88 1.52 6.88 4.56 0 1.84-1.52 3.28-2.88 4.48l-31.44 28.08c-3.52 3.12-7.12 6.4-8.88 10.72-1.84 4.32-1.28 10 2.48 12.8 2.48 1.84 5.76 2.08 8.88 2.16 14 .24 28-1.92 41.76-4.48 48.8-8.96 96.64-22.88 142.64-41.28 8.4-3.36 17.44-7.52 21.52-15.68 4.64-9.44-.32-22.24-10.08-26.16-5.84-2.32-12.4-1.68-18.56-2.8-6.16-1.12-12.8-5.36-12.88-11.6-.08-10.32 16.72-14.32 17.2-24.64.24-5.44-4.72-10.08-10.08-11.28-5.36-1.2-10.96.24-16.16 1.92 0 0-95.04 24.4-133.68 41.76-8.88 3.92-17.76 8.24-23.92 15.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009BEF",
    fillRule: "evenodd",
    d: "M193.6 31.4c1.768 0 3.2 1.61 3.2 3.6s-1.432 3.6-3.2 3.6c-1.769 0-3.2-1.61-3.2-3.6s1.431-3.6 3.2-3.6zM58.4 137.8c1.769 0 3.2 1.611 3.2 3.6 0 1.99-1.431 3.6-3.2 3.6-1.768 0-3.2-1.61-3.2-3.6 0-1.989 1.432-3.6 3.2-3.6zM208.8 95.4c3.537 0 6.4 2.863 6.4 6.4 0 3.537-2.863 6.4-6.4 6.4-3.537 0-6.4-2.863-6.4-6.4 0-3.537 2.863-6.4 6.4-6.4zM65.2 14.6c3.325 0 6 2.675 6 6s-2.675 6-6 6-6-2.637-6-5.962c0-3.325 2.675-6.038 6-6.038z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9EAFC",
    fillRule: "evenodd",
    d: "M35.92 95.76c5.84 0 10.56 4.72 10.56 10.56 0 5.84-4.72 10.56-10.56 10.56-5.84 0-10.56-4.72-10.56-10.56 0-5.84 4.72-10.56 10.56-10.56z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F1FD",
    fillRule: "evenodd",
    d: "M20.48 125.76c3.6 0 6.48 2.88 6.48 6.48 0 3.6-2.88 6.48-6.48 6.48-3.6 0-6.48-2.88-6.48-6.48 0-3.6 2.96-6.48 6.48-6.48z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2FB",
    fillRule: "evenodd",
    d: "M71.28 90c9.2 0 16.64 7.44 16.64 16.64s-7.44 16.64-16.64 16.64-16.64-7.44-16.64-16.64S62.08 90 71.28 90z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9EAFC",
    fillRule: "evenodd",
    d: "M35.92 124.16c1.76 0 3.28 1.44 3.28 3.28 0 1.76-1.44 3.28-3.28 3.28-1.76 0-3.28-1.44-3.28-3.28.08-1.84 1.52-3.28 3.28-3.28z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F1FD",
    fillRule: "evenodd",
    d: "M4.003 100.2c2.265 0 3.997 1.867 3.997 4 0 2.267-1.865 4-3.997 4-2.264 0-3.996-1.867-3.996-4-.134-2.133 1.732-4 3.996-4z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#009BEF",
    fillRule: "evenodd",
    d: "M75.2 141.8c5.272 0 9.6 4.328 9.6 9.6 0 5.272-4.328 9.6-9.6 9.6-5.272 0-9.6-4.328-9.6-9.6.079-5.351 4.328-9.6 9.6-9.6z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00356D",
    fillRule: "evenodd",
    d: "M151.803 3.894s.387 4.551-9.296 7.843c-9.682 3.293-17.332.775-20.043 5.713-2.711 4.939.871 9.199.871 9.199s-2.808 4.163-1.065 7.746c1.743 3.583 9.102 1.937 9.102 1.937l25.853-19.27-5.422-13.168z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#00356D",
    fillRule: "evenodd",
    d: "M156.063.409c-.968-.097-2.033.193-2.614.871-2.324 2.614-3.389 8.327-2.905 9.683.194.678 1.259 2.324 2.324 3.97 1.356 2.033 4.261 1.84 5.326-.387l4.551-9.296c.871-1.84-.291-4.067-2.324-4.357l-4.358-.484z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6CDF7",
    fillRule: "evenodd",
    d: "M157.419 25.584s-9.393 32.825 24.885 37.279c-1.743 3.486-2.034 4.938-2.034 4.938s-34.955-8.23-33.212-29.242c6.197-13.169 10.361-12.975 10.361-12.975z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99C25",
    fillRule: "evenodd",
    d: "M99.225 79.324l-18.978-9.005c-.581-.29-1.356-.097-1.743.387L56.427 97.043c-.871 1.065.097 2.711 1.452 2.42l17.042-3.679c.097 0 .29-.096.387-.193l24.014-13.653c1.065-.581.968-2.13-.097-2.614zM112.587 119.701l-15.105 17.526c-.678.871-1.937 1.065-2.905.677l-30.985-14.33c-1.259-.581-1.065-2.518.29-2.808l17.623-3.776 31.082 2.711z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C6418",
    fillRule: "evenodd",
    d: "M84.12 113.891l-6.487.775c-1.646.193-3.099-.872-3.486-2.421l-2.227-10.361c-.387-1.646.58-3.195 2.13-3.679l6.197-1.84 3.873 17.526z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB72C",
    fillRule: "evenodd",
    d: "M174.267 112.051c-.581.291-1.162.485-1.646.678-.581.291-1.162.484-1.646.678-5.035 2.033-10.167 3.679-15.395 4.841-25.466 5.616-55.87 3.97-74.17-.484l-5.133-22.851c14.815-11.716 41.733-26.24 67.199-31.76 5.229-1.162 10.651-1.84 16.074-2.033.58 0 1.258-.097 1.839-.097h1.84c32.825-.484 52.384 13.556 52.384 13.556s-11.232 24.207-41.346 37.472z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB72C",
    fillRule: "evenodd",
    d: "M173.783 112.342c-.581.29-1.162.484-1.743.775-7.359-6.778-12.297-15.106-14.233-24.11-1.937-9.006-.969-18.688 2.905-27.887h1.839c19.463-.29 42.605 5.713 55.289 9.49 4.551 1.355 5.81 7.067 2.324 10.36-9.199 8.424-26.24 22.561-46.381 31.372z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99C25",
    fillRule: "evenodd",
    d: "M163.228 61.023h-1.839c-.581 0-1.259 0-1.84.097-1.743 4.357-2.905 8.811-3.389 13.169-.581 5.131-.387 10.166.775 15.105 1.065 4.938 3.001 9.682 5.616 14.04 2.324 3.776 5.228 7.359 8.617 10.554.581-.194 1.162-.484 1.743-.678.581-.193 1.162-.484 1.743-.774-7.262-6.488-12.297-14.621-14.33-23.917-2.131-9.199-.969-18.688 2.904-27.596z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M169.619 62.96c8.037.387 31.857 4.647 44.154 7.94.678.193.484 1.161-.194 1.065-13.265-1.84-40.861-6.197-42.701-3.777-1.162-3.001-1.259-5.228-1.259-5.228z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99C25",
    fillRule: "evenodd",
    d: "M105.712 104.015l-37.472 8.133-5.81-.484c-1.452-.097-1.84-2.033-.581-2.711l5.035-2.808 37.473-8.134c1.646-.387 3.292.678 3.679 2.324.291 1.646-.678 3.292-2.324 3.68z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A426D",
    fillRule: "evenodd",
    d: "M153.546 120.96l8.617 9.295c1.162 1.937-1.065 4.164-3.001 3.002l-9.586-5.422-.388.774c-.193.291-.581.387-.871.194l-2.034-1.356c-.193-.193-.29-.484-.193-.678l2.42-6.778 5.036.969z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7DADF",
    fillRule: "evenodd",
    d: "M158.097 91.524c.871-1.065.29-1.646-.968-1.937-11.136-2.13-33.89-1.355-39.7-8.714-5.81-7.36.194-17.139 4.357-20.334l18.301 6.197c2.324.968 20.818 6.778 30.113 12.394 3.874 2.324 3.389 5.519 2.131 8.424-1.066 2.42-18.204 34.374-18.204 34.374s-3.776-.387-6.391-.968c-.097-.097 3.583-24.11 10.361-29.436z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E67863",
    fillRule: "evenodd",
    d: "M169.813 65.38l7.359-1.646c.581-.097.968.581.484.968l-1.743 1.453 4.067 2.614c1.065.678 1.259 2.227.29 3.196-.677.58-1.646.774-2.42.29 0 0-6.391-1.452-8.134-4.357-1.743-2.905.097-2.518.097-2.518z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071E9",
    fillRule: "evenodd",
    d: "M157.806 24.616c-.194 18.494-13.169 39.602-14.911 43.282-.194.29-.581.484-.872.387l-22.948-7.552c-.387-.097-.678-.581-.581-1.066 2.711-11.813 7.746-17.816 15.396-27.402 2.517-3.099 8.52-10.942 14.136-12.104 4.067-.677 9.78 1.55 9.78 4.455z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C0E4",
    fillRule: "evenodd",
    d: "M160.808 19.193L157.71 25.1l-5.81-4.551 5.519-6.488 3.389 5.132z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C0E4",
    fillRule: "evenodd",
    d: "M166.133 4.766c3.196 3.68 3.68 10.167 2.421 13.459-2.033 5.52-8.327 3.486-10.36.194-2.034-3.293-2.131-12.975-.678-14.621 1.452-1.743 8.424-.097 8.424-.097l.193 1.065z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00356D",
    fillRule: "evenodd",
    d: "M155.869 4.475c-.484-.968-.387-2.323.291-3.195.968-1.259 2.808-1.452 4.26-1.162 1.55.29 2.905 1.065 4.358 1.356.774.193 1.646.193 2.42.097 1.356-.29 2.518 1.065 1.937 2.227 0 0-1.356 3.098-3.68 3.582-2.227.484-4.55-.58-6.584-1.549.194.097-2.421-.387-3.002-1.356z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00356D",
    fillRule: "evenodd",
    d: "M165.649 5.734c-.774 9.274-8.521 7.069-8.521 7.069l-3.776-6.585s11.426-4.357 12.297-.484z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C0E4",
    fillRule: "evenodd",
    d: "M154.998 10.576c1.162-.29 2.421.677 2.905 2.13.484 1.55-.097 3.098-1.162 3.389-1.162.29-2.421-.678-2.905-2.13-.581-1.55 0-3.002 1.162-3.39z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2FB",
    fillRule: "evenodd",
    d: "M171.072 69.35c-.291-2.517-.291-4.454-.291-4.454s-27.402-3.583-23.239-26.918c.485-2.518 1.259-4.938 2.324-7.262 3.292-7.456-5.809-8.715-10.457-1.259-7.069 11.523-7.746 36.988 31.663 39.893z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M151.222 19.29l-3.583.581 6.681 7.36c.291.29.872.386 1.162.096l2.711-2.227-5.906-5.52c-.291-.193-.678-.29-1.065-.29z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/MainLogo.047d5dc66d1df85c4e1d9c6483730a3e.svg";
export { ForwardRef as ReactComponent };